import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Card, Grid, Icon, Text } from "~/components-shared";
import { useDispatch } from "react-redux";
import styled, { useTheme } from "styled-components";
import footprintActionCreators from "~/store/footprints/actions";
import { FootprintActionEnum } from "~/store/footprints/types";
import useAbacExt from "~/hooks/abac";
import { AuthoritiesEnum } from "~/types/enums";
const FixedCard = styled(Card)`
  position: sticky;
  bottom: 1em;
  z-index: 2;
  width: initial;
`;
const FootprintSelectionCard = _ref => {
  let {
    selectionCount,
    selection,
    setSelection
  } = _ref;
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const {
    userHas
  } = useAbacExt();
  const deleteFootprints = () => {
    dispatch(footprintActionCreators.actionChanged(FootprintActionEnum.BULK_DELETE, null, {
      footprintIds: selection || [],
      count: selection.length
    }));
  };
  const moveFootprints = () => {
    dispatch(footprintActionCreators.actionChanged(FootprintActionEnum.BULK_MOVE, null, {
      footprintIds: selection,
      count: selection.length
    }));
  };
  const testFootprints = () => {
    dispatch(footprintActionCreators.actionChanged(FootprintActionEnum.TEST_DETECTION, null, {
      footprintIds: selection,
      count: selection.length
    }));
  };
  return /*#__PURE__*/React.createElement(FixedCard, {
    s: {
      p: 2
    },
    border: true,
    color: colors.background.secondary,
    align: "left",
    maxWidth: "26rem"
  }, /*#__PURE__*/React.createElement(Grid, {
    cols: 8,
    gap: 2,
    template: userHas(AuthoritiesEnum.EXPERIMENTAL) ? "auto auto auto 1fr auto" : "auto auto 1fr auto",
    align: "center",
    fullWidth: true
  }, userHas(AuthoritiesEnum.EXPERIMENTAL) && /*#__PURE__*/React.createElement(Button, {
    onClick: testFootprints,
    color: "transparent",
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("TopicFootprintSelectionCard.testDetections"),
    outline: false,
    s: {
      p: 2
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 5,
    src: "encrypted",
    color: "primary"
  })), /*#__PURE__*/React.createElement(Button, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("TopicFootprintSelectionCard.deleteItems", {
      count: selectionCount
    }),
    onClick: deleteFootprints,
    color: "transparent",
    outline: false,
    s: {
      p: 2
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 5,
    src: "bin"
  })), /*#__PURE__*/React.createElement(Button, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("TopicFootprintSelectionCard.moveItems", {
      count: selectionCount
    }),
    onClick: moveFootprints,
    color: "transparent",
    outline: false,
    s: {
      p: 2
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 5,
    src: "share"
  })), /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary"
  }, t("TopicFootprintSelectionCard.selected", {
    count: selectionCount
  })), /*#__PURE__*/React.createElement(Button, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("TopicFootprintSelectionCard.cancelSelection"),
    onClick: () => setSelection([], true),
    color: "transparent",
    outline: false,
    s: {
      p: 2
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 5,
    src: "cross"
  }))));
};
export default FootprintSelectionCard;